import Immutable from 'immutable';
import {handleActions} from 'redux-actions';

const defaultState = Immutable.fromJS({
  access_token: null,
  term_agreed: null,
  isFetchingSession: false,
  uuid: null,
  code: null
})

export default handleActions({
  SESSION_LOGIN_START: (state, action) => {
    return state.merge(action.payload)
  },
  SESSION_LOGIN_FINISH: (state, action) => {
    return state.merge(action.payload).merge({isFetchingSession: true})
  },
  SESSION_DEFAULT: (state, action) => {
    return state.merge(action.payload)
  },
  SESSION_AGREE_TERM: (state, action) => {
    return state;
  }
}, defaultState)
